export function generateStatusArray(sections){
	const status_array = {};
	sections.forEach( section => {
		status_array[section.store_key] = null;
	})
	return status_array;
}

export function generateComponentArray(sections){
	return sections
	.filter( ({ store_key }) => store_key !== 'attachments' ) // Print view does not need to display attachments
	.map( ({ component }) => component );
}
